import React from "react";
import useReveal from "../../hooks/useReveal";
import { waUrl } from "../../config/bdk";

const eventChanges = [
  { label: "Cambio pequeño", price: "$250 MXN" },
  { label: "Cambio mediano", price: "$500 MXN" },
  { label: "Cambio grande", price: "Desde $900 MXN" },
];

const monthly = [
  {
    name: "Plan Básico",
    price: "$390",
    features: [
      "Hasta 2 cambios pequeños al mes",
      "Texto, horarios, teléfonos y precios simples",
      "Revisión básica de funcionamiento visual",
    ],
  },
  {
    name: "Plan Comercial",
    price: "$790",
    features: [
      "Hasta 4 cambios pequeños o 2 medianos al mes",
      "Cambios de promociones e imágenes",
      "Actualización de precios y servicios",
      "Revisión básica mensual",
    ],
    featured: true,
  },
  {
    name: "Plan Plus",
    price: "$1,490",
    features: [
      "Hasta 8 cambios pequeños o 4 medianos al mes",
      "Cambios de banners y ajustes de secciones",
      "Atención prioritaria",
    ],
  },
];

const Maintenance = () => {
  useReveal();
  return (
    <section
      id="mantenimiento"
      data-testid="section-mantenimiento"
      className="bdk-section"
    >
      <div className="container-bdk">
        <div className="max-w-[760px] mx-auto text-center mb-14 bdk-reveal bdk-reveal--up">
          <p className="kicker">Mantenimiento</p>
          <h2 className="font-display text-[38px] sm:text-[48px] md:text-[56px] lg:text-[64px]">
            Después de publicada, también
            <br />
            podemos ayudarte con cambios.
          </h2>
        </div>

        {/* Event changes */}
        <div className="grid md:grid-cols-3 gap-4 mb-10">
          {eventChanges.map((c, i) => (
            <div
              key={c.label}
              data-testid={`maintenance-event-${i}`}
              className="p-6 rounded-[12px] bdk-reveal bdk-reveal--up"
              style={{
                background: "var(--paper)",
                border: "1px solid var(--line)",
                borderLeft: "4px solid var(--red)",
                "--reveal-delay": `${i * 70}ms`,
              }}
            >
              <p className="text-[10px] uppercase tracking-widest font-black text-[#666873]">
                {c.label}
              </p>
              <p className="font-display text-[36px] font-black text-[#111218] mt-1">
                {c.price}
              </p>
            </div>
          ))}
        </div>

        {/* Monthly plans */}
        <div className="grid md:grid-cols-3 gap-4">
          {monthly.map((m, i) => (
            <article
              key={m.name}
              data-testid={`maintenance-monthly-${i}`}
              className={`relative p-8 rounded-[14px] bdk-reveal bdk-reveal--up ${
                m.featured ? "md:-translate-y-3 featured-pulse" : ""
              }`}
              style={{
                background: m.featured ? "var(--ink)" : "#fff",
                color: m.featured ? "#fff" : "inherit",
                border: m.featured
                  ? "2px solid var(--red)"
                  : "1px solid var(--line)",
                "--reveal-delay": `${i * 90}ms`,
              }}
            >
              {m.featured && (
                <span
                  className="absolute -top-[15px] left-1/2 -translate-x-1/2 px-3.5 py-1.5 rounded-full whitespace-nowrap"
                  style={{
                    background: "var(--red)",
                    color: "#fff",
                    fontSize: "10px",
                    fontWeight: 800,
                    textTransform: "uppercase",
                    letterSpacing: ".5px",
                  }}
                >
                  Recomendado
                </span>
              )}
              <h3 className="font-display text-[26px] uppercase leading-none">
                {m.name}
              </h3>
              <div
                className="font-display font-black leading-none my-3"
                style={{
                  color: m.featured ? "#fff" : "var(--red)",
                  fontSize: "44px",
                }}
              >
                {m.price}
                <small
                  className="text-[11px] ml-2 font-black"
                  style={{ color: m.featured ? "#b8b9c1" : "#666873" }}
                >
                  MXN/mes
                </small>
              </div>
              <ul className="grid gap-1.5 list-none">
                {m.features.map((f, j) => (
                  <li
                    key={j}
                    className="relative pl-5 text-[13px]"
                    style={{ color: m.featured ? "#e2e2e8" : "inherit" }}
                  >
                    <span
                      className="absolute left-0 top-0 font-black"
                      style={{ color: "var(--red)" }}
                    >
                      ✓
                    </span>
                    {f}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        {/* Annual */}
        <div
          className="mt-8 p-7 md:p-8 rounded-[14px] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 bdk-reveal bdk-reveal--up"
          style={{
            background: "var(--paper)",
            border: "1px solid var(--line)",
            borderLeft: "4px solid var(--red)",
          }}
        >
          <div>
            <p className="text-[10px] uppercase tracking-widest font-black text-[#666873]">
              Plan anual
            </p>
            <h3 className="font-display text-[24px] md:text-[28px] uppercase leading-none mt-1">
              Plan Anual de Mantenimiento · $1,990 MXN
            </h3>
            <p className="text-[#666873] text-[13px] mt-2 max-w-[540px]">
              Hasta 12 cambios pequeños al año, revisión básica trimestral,
              precios preferentes para cambios adicionales.
            </p>
          </div>
          <a
            href={waUrl(
              "Hola, me interesa el Plan Anual de Mantenimiento Web ($1,990 MXN) de BDKSISTEMAS."
            )}
            target="_blank"
            rel="noreferrer"
            data-testid="maintenance-annual-cta"
            className="bdk-btn bdk-btn--primary flex-shrink-0"
          >
            Contratar plan anual
          </a>
        </div>

        <p className="mt-6 text-[11px] text-[#666873] max-w-3xl">
          Los planes de mantenimiento son únicamente para cambios de contenido.
          No incluyen dominio, hosting, correos empresariales ni soporte técnico
          de servidores.
        </p>
      </div>
    </section>
  );
};

export default Maintenance;
